export enum MatchRunStatus {
    Pending = 1,
    Running = 2,
    Completed = 3
}